import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from 'DesignSystem/Buttons';
import { RadioButtons } from 'DesignSystem';

export class UploadDocumentBody extends React.Component {
  constructor(props) {
    super(props);
    this.createTemplate = this.createTemplate.bind(this);
    this.onRadioButtonChange = this.onRadioButtonChange.bind(this);
    this.uploadOnClick = this.uploadOnClick.bind(this);

    this.state = {
      selection: 'freewrite',
      defaultCheckFreewrite: true,
    };
  }

  onRadioButtonChange(e) {
    const { value } = e.target;
    if (value === 'custom-template') {
      window._track('Create Template | Freewrite Upload Modal', 'Freewrite-Builder-Member');
    }
    this.setState({
      selection: value,
      defaultCheckFreewrite: value === 'freewrite',
    });
  }

  uploadOnClick() {
    window._track('Open Document | Freewrite Upload Modal', 'Freewrite-Builder-Member');
    this.props.closeFreeWriteUploadModal();
    const win = window.open(this.props.redirectURL, '_blank');
    win.focus();
  }

  async createTemplate() {
    const conversionResult = await this.props.convertToCustomTemplateFromDocumentType(
      this.props.newUploadDocumentType,
      this.props.newUploadSessionKey,
      this.props.newUploadSessionHash,
    );
    window._track('Open in Template Builder | Freewrite Upload Modal', 'Freewrite-Builder-Member');
    const documentType = conversionResult.custom_template.document_type;
    const win = window.open(`/self-serve-builder?documentType=${documentType}`, '_blank');
    win.focus();
    this.props.closeFreeWriteUploadModal();
  }

  render() {
    const radioButtonOptions = [
      { text: 'Make it fillable to get back completed copies from others', value: 'custom-template', defaultChecked: false },
      { text: 'Continue editing with the PDF editor', value: 'freewrite', defaultChecked: true },
    ];
    return (
      <div className="template-upload-modal-contents">
        <h2 className="template-upload-modal-header">
          Success! What would you like to do with the uploaded document?
        </h2>
        <h6 className="new-feature-header">New!</h6>
        <div className="radio-container">
          <RadioButtons
            id="myTemplatesAddRecipients"
            onChange={this.onRadioButtonChange}
            options={radioButtonOptions}
          />
        </div>
        <div className="row">
          <PrimaryButton
            className="btn btn-success open-document-btn"
            onClick={this.state.selection === 'freewrite' ?
              this.uploadOnClick :
              this.createTemplate
            }
          >
            Open Document
          </PrimaryButton>
        </div>
      </div>
    );
  }
}

UploadDocumentBody.propTypes = {
  closeFreeWriteUploadModal: PropTypes.func.isRequired,
  convertToCustomTemplateFromDocumentType: PropTypes.func.isRequired,
  redirectURL: PropTypes.string,
};

UploadDocumentBody.defaultProps = {
  redirectURL: '',
};

export default UploadDocumentBody;



// WEBPACK FOOTER //
// ./src-react/Modals/content/UploadDocumentBodyContent/UploadDocumentBody.jsx